import {
  MiniTileContent,
  Title,
  Text,
} from "components/components/Iris/LandingPageInfo/GetStartedSection/Tile/style";
import Panel from "components/shared/Panel/Panel";
import React from "react";

type Props = {
  title: string | number;
  text: JSX.Element | string;
};

const Tile: React.FC<Props> = ({ title, text }) => (
  <Panel isMiniTile>
    <MiniTileContent>
      <Title>{title}</Title>
      <Text>{text}</Text>
    </MiniTileContent>
  </Panel>
);

export default Tile;
